import React from "react";
import { Alert } from "reactstrap";
import PropTypes from "prop-types";

const propTypes = { accountholderName: PropTypes.string.isRequired };
const ClientAdminPaymentWarning = ({ accountholderName }) => {
  return (
    <Alert color="warning">
      <h5>Administrators:</h5>

      <p>
        Please note that if you use a card to purchase a campaign, that card will be saved to{" "}
        <strong>{accountholderName}'s</strong> account.
      </p>

      <p>
        To purchase without saving a credit card, please contact your account manager for
        alternatives.
      </p>
    </Alert>
  );
};

ClientAdminPaymentWarning.propTypes = propTypes;

export default ClientAdminPaymentWarning;
